import * as React from 'react';
import { useTranslation } from 'react-i18next';
import ResultsError from '@websky/core/src/ResultsError';
import css from './ResultsEmptyError.css';
const ResultsEmptyError = props => {
    const { t } = useTranslation();
    const header = (React.createElement("div", { className: css.header },
        props.header,
        React.createElement("span", null, t('If the flight is operating on the selected date, but there are no available seats, you can use the free “Waiting List” service by calling phone number 0065'))));
    return React.createElement(ResultsError, Object.assign({}, props, { header: header }));
};
export default ResultsEmptyError;
